









































import {
  Vue, Component, Watch,
} from 'vue-property-decorator';
import CreateCoaDialog from '@/components/dialog/CreateCOADialog.vue';
import { ASSET_URL } from '../../common/config';
import { CREATE_COA_DIALOG } from '../../common/constants';
import ProductCOA from '../../common/model/ProductCOA';
import { eventBus } from '../../main';
import brandModule from '../../store/modules/brand.module';
import errorModule from '../../store/modules/error.module';
import productModule from '../../store/modules/product.module';
import Brand from '../../common/model/Brand';

@Component({
  components: {
    CreateCoaDialog,
  },
})
export default class AdminAssetsPage extends Vue {
  search = '';

  cdnUrl = ASSET_URL;

  headers = [
    { text: 'METRC ID', value: 'title' },
    { text: 'Product Name', value: 'product.title' },
    { text: 'Added', value: 'created_on' },
    { text: 'View COA', value: 'pdf_file' },
  ];

  get currentCOAs(): Array<ProductCOA> {
    return productModule.productCOAs;
  }

  get currentBrand(): Brand | null {
    return brandModule.brand;
  }

  get secondaryColor(): string {
    return '#000000';
  }

  @Watch('currentBrand')
  async brandUpdated(): Promise<void> {
    if (!brandModule.brand) { return; }
    await productModule.fetchAllCoaByBrand(brandModule.brand.id);
    errorModule.clearError();
  }

  async created(): Promise<void> {
    if (productModule.productCOAs.length > 0 || !brandModule.brand) { return; }
    await productModule.fetchAllCoaByBrand(brandModule.brand.id);
    errorModule.clearError();
  }

  createCoa(): void {
    eventBus.$emit(CREATE_COA_DIALOG);
  }

  dateToString(dateString: string): string {
    const date = new Date(dateString);
    const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
    const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    return `${month}/${day}/${date.getFullYear()}`;
  }
}
